































































































































import { Component, InjectReactive, Vue } from 'vue-property-decorator';
import { BvTableFieldArray } from 'bootstrap-vue';

import { FeedTank, Sensor, Transceiver } from '@/api';
import { FeedProduct, feedTankAuditFields, FeedType } from '../../../models';

import InformationRow from '@/components/display/information-row.vue';
import FeedTankVolumeDisplay from './components/FeedTankVolumeDisplay.vue';
import LocationRow from '@/components/display/information-rows/location-row.vue';
import LastCheckInTag from '@/components/display/information-rows/last-check-in-tag.vue';
import LiveAtRow from '@/components/display/information-rows/live-at-row.vue';
import ChangelogLink from '@/components/display/changelog-link.vue';
import { formattedStatus } from '@/common/StatusUtil';

@Component({
	components: {
		ChangelogLink,
		LastCheckInTag,
		LiveAtRow,
		LocationRow,
		InformationRow,
		FeedTankVolumeDisplay,
	},
	methods: {
		formattedStatus,
	},
})
export default class FeedTankGeneralSection extends Vue {
	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct;

	@InjectReactive('selectedFeedTank')
	public feedTank!: FeedTank & {
		transceiver: Transceiver | null;
		sensor: Sensor | null;
		feedtype: FeedType | null;
	};

	public get feedTypeName(): string {
		return this.feedTank.feedtype?.name ?? 'No feed type';
	}

	public get auditFields(): BvTableFieldArray {
		return feedTankAuditFields;
	}

	private sortedParameters(obj: any, parameters: string) {
		const split = parameters
			?.replace(/(\n|\r\n|\r)/g, '\n')
			.split('\n')
			.map(x => x.split('|')[1]);
		return split ?? Object.keys(obj ?? {}) ?? [];
	}
}
